// generated from 861 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const firstNameFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("first_name_filter"),
  comparison_key: z.enum([
    "1", // 299 (34.73%)
    "11", // 277 (32.17%)
    "10", // 225 (26.13%)
    "12", // 32 (3.72%)
    "2", // 27 (3.14%)
    "17", // 1 (0.12%)
  ]),
  display_name: z.string(),
  // undefined: 336 (39.02%), defined 525 (60.98%)
  raw_value: z.string().optional(),
  value: z.string(),
  varies_by_app_group: z.literal(false),
});
